import React, { PureComponent } from 'react';
import styled from '@emotion/styled';
import { withWindowDimensions } from '@rosetta/react-common-ui';
import { MousySpinner } from './MousySpinner';
import { isMobile as isMobileDetected } from 'react-device-detect';

const MouseCatcherDiv = styled.div((props) => {
  let style = {
    position: !props.isMobile ? 'fixed' : 'absolute',
    top: '0px',
    bottom: '0px',
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    zIndex: '1000',
    backgroundColor: 'rgba(255, 255, 255, 0.45)'
  };
  
  if (props.left) {
    style.left = props.left;
  }
  if (props.isMobile) {
    style.marginTop = !props.loginCatcher ? '-304px' : '-204px';
    style.marginBottom = '-262px';
    //style.position = !props.loginCatcher ? 'relative' : 'absolute';
    style.minHeight = props.windowHeight + 100 + 'px';
  }
  return style;
});

const MouseSpinner = styled(MousySpinner)((props) => {
  let style = {};
  if (props.isMobile) {
    style.marginTop = '-300px';
    style.backgroundColor = 'pink';
  }
  return style;
});

export class MouseCatcher extends PureComponent {
  render = () => {
    const isMobile = isMobileDetected;
    return (
      <MouseCatcherDiv
        data-qa="MouseCatcher"
        isMobile={isMobile}
        loginCatcher={this.props.loginCatcher}
        windowHeight={this.props.clientHeight}
        left={this.props.left || "auto"}
      >
        <MouseSpinner isMobile={isMobile} loginCatcher={this.props.loginCatcher} />
      </MouseCatcherDiv>
    );
  };
}

export const MouseCatcherContainer = withWindowDimensions(MouseCatcher);



// WEBPACK FOOTER //
// ./src/modules/app/util/MouseCatcher.jsx